import moment from 'moment';

export const formatEventOccurrenceDate = (date: string) => {
  return moment.utc(date).format('ddd. DD/MM');
}

export const formatEventOccurrenceTime = (startTime: string | null, endTime: string | null) => {
  const formattedStartTime = startTime ? moment.utc(startTime).format('LT') : null;
  const formattedEndTime = endTime ? moment.utc(endTime).format('LT') : null;

  if (formattedEndTime)
    return `${formattedStartTime} - ${formattedEndTime}`;
  else if (formattedStartTime)
    return formattedStartTime;

  return null;
}

export const formatMoney = (amount: number, defaultValue: string = '') => {
  if (!amount) return defaultValue;

  return Math.round(amount).toLocaleString() + '₽';
}

export const formatPhoneNumber = (num: string | null | undefined): string => {
  if (!num) {
    return "";
  }

  // Remove all non-digit characters
  const digits = num.replace(/\D/g, "");

  // Validate that the number has exactly 11 digits and starts with '7' or '8'
  if (digits.length === 11 && ['7', '8'].includes(digits[0])) {
    // Extract parts of the number
    const countryCode = digits[0];
    const areaCode = digits.substring(1, 4);
    const firstTwo = digits.substring(4, 7);
    const nextTwo = digits.substring(7, 9);
    const lastTwo = digits.substring(9, 11);

    // Format the number
    return `+${countryCode} (${areaCode}) ${firstTwo}-${nextTwo}-${lastTwo}`;
  } else {
    // Return the original number if it doesn't match the expected format
    return num;
  }
}